import React from "react";
import { Button, Divider, Menu, Modal, Tabs } from "antd";
import {
  BgColorsOutlined,
  DatabaseFilled,
  DownloadOutlined,
} from "@ant-design/icons";
import config, { env, wms_uploads_cdn } from "../config";
import AuthService from "../auth/AuthService";

const Auth = new AuthService();

const templateConfig = [
  {
    key: "1",
    tabLabel: "Aisle",
    icon: <DatabaseFilled />,
    fileName: "WMS Aisle Template.csv",
    description: "CSV files with column headers that match the Aisle fields...",
  },
  {
    key: "2",
    tabLabel: "Location",
    icon: <BgColorsOutlined />,
    fileName: "WMS Location Template.csv",
    description: "CSV files with column headers that match the Location fields...",
  },
  {
    key: "3",
    tabLabel: "Picking Location",
    icon: <BgColorsOutlined />,
    fileName: "Product Location Template.csv",
    description: "CSV files with column headers that match the fields...",
  },
  {
    key: "4",
    tabLabel: "Opening Balance",
    icon: <BgColorsOutlined />,
    fileName: "Opening Balance Template.csv",
    description: "CSV files with column headers that match the fields...",
  },
];

const ImportModal = ({ isModalOpen, setIsModalOpen }) => {
  const handleCancel = () => setIsModalOpen(false);
  const handleOk = () => setIsModalOpen(false);

  const getMenuItem = ({ key, icon, fileName, tabLabel }) => [
    {
      key,
      label: (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>{icon} {tabLabel}</span>
          <a
            href={`${wms_uploads_cdn}/${env}/imports/templates/${encodeURIComponent(fileName)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button icon={<DownloadOutlined />}>Download</Button>
          </a>
        </div>
      ),
    },
  ];

  return (
    <Modal
      width={800}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      title="Import Templates"
      footer={null}
    >
      <Divider />
      <Tabs
        defaultActiveKey="1"
        tabPosition="left"
        items={templateConfig.map((item) => ({
          label: item.tabLabel,
          key: item.key,
          children: (
            <>
              <span style={{ fontWeight: 500 }}>
                Browse {item.tabLabel} Import Templates
              </span>
              <br />
              <span style={{ color: "rgb(116, 115, 114)", fontSize: 13 }}>
                {item.description}
              </span>
              <div style={{ marginTop: 10 }}>
                <Menu
                  style={{ width: "100%" }}
                  selectable={false}
                  mode="vertical"
                  items={getMenuItem(item)}
                />
              </div>
            </>
          ),
        }))}
      />
    </Modal>
  );
};

export default ImportModal;
